class ApiError extends Error {
  constructor(
    public message: string,
    private readonly status: number,
    private readonly statusText: string,
    private readonly url: string,
    private readonly response: Response
  ) {
    super(message);
    this.status = status;
    this.statusText = statusText;
    this.url = url;
    this.response = response;
  }

  /**
   * Gets the error message
   */
  getMessage(): string {
    return this.message;
  }

  /**
   * Gets the HTTP status code
   */
  getStatus(): number {
    return this.status;
  }

  /**
   * Gets the HTTP status text
   */
  getStatusText(): string {
    return this.statusText;
  }

  /**
   * Gets the URL that caused the error
   */
  getUrl(): string {
    return this.url;
  }

  /**
   * Gets the response that caused the error
   */
  getResponse(): Response {
    return this.response;
  }
}

export { ApiError };
